
import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { Loader } from "./ui/loader";

export function RootRedirect() {
  const { isAuthenticated, isLoading, currentUser } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  // Authenticated users go to dashboard regardless of role
  // The dashboard page itself handles showing different views for parents vs children
  return <Navigate to="/dashboard" replace />;
}
